import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { HelperService } from 'app/services/helper.service';
import { HTTPService } from 'app/services/http.service';

@Component({
  selector: 'app-catalog-activity-logs',
  templateUrl: './catalog-activity-logs.component.html',
  styleUrls: ['./catalog-activity-logs.component.scss'],
})
export class CatalogActivityLogComponent implements OnInit {
  @Input() activityLog: any = {};
  @Input() companyLocalization: boolean = false;
  @Input() currentLang: string = 'en';
  constructor(private dialogService: DialogService, public helperService: HelperService, private httpService: HTTPService) {}

  ngOnInit() {}

  navigateToPO(log) {
    this.helperService.openPageInNewExistingTab(`${log?.redirectUrl}`, log?.orderId);
  }
}
